<template>
  <v-navigation-drawer
    v-model="sideNav"
    temporary
    location="left"
    width="300"
    style="z-index: 11111; border-radius: 0 !important"
    class="rounded-0"
  >
    <v-toolbar flat>
      <v-btn
        icon="$mdiClose"
        size="small"
        class="rounded-xl on-surface ml-3 mr-1"
        @click.stop="sideNav = !sideNav"
      ></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row class="ma-1">
      <v-col
        v-for="item in menuItems"
        :key="item.title"
        class="nav-list"
        :cols="getCols(item)"
      >
        <v-btn
          v-if="item.component && !item.meta.content"
          :to="item.path"
          :class="getClass(item)"
        >
          <template #prepend>
            <v-icon :icon="item.icon"></v-icon>
          </template>
          <v-badge v-if="item.badge" color="red" :content="item.badge" inline>
            <span>{{ $t(item.title) }}</span>
          </v-badge>
          <span v-else>{{ $t(item.title) }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-list>
      <div v-for="item in menuContent" :key="item.title">
        <v-list-group v-if="item.child" :value="item.title">
          <template #activator="{ props }">
            <v-list-item v-bind="props">{{ $t(item.title) }}</v-list-item>
          </template>
          <v-list-item
            v-for="(subitem, i) in item.child"
            :key="i"
            :value="subitem.title"
            :to="subitem.path"
            class="rounded-0"
            >{{ $t(subitem.title) }}</v-list-item
          >
        </v-list-group>
        <v-list-item v-if="!item.child" :value="item.title" :to="item.path">{{
          $t(item.title)
        }}</v-list-item>
      </div>

      <v-divider></v-divider>
      <v-list-item>
        <locale-switcher :locales="['en', 'de', 'nl']"></locale-switcher>
      </v-list-item>
      <v-list-item>
        <theme-switcher />
      </v-list-item>
    </v-list>
    <v-footer
      class="mb-12 text-disabled text-subtitle-2 d-flex flex-column justify-start align-start"
      ><em> version: {{ appVersion }} </em>
      <em>url: {{ appUrl }}</em>
    </v-footer>
  </v-navigation-drawer>
  <Loader :visible="loading" />
  <v-app-bar color="transparent">
    <v-btn
      icon="$mdiMenu"
      size="small"
      class="rounded-xl on-surface ml-3 mr-3"
      @click.stop="sideNav = !sideNav"
    ></v-btn>
    <div
      :class="
        $vuetify.display.smAndDown
          ? 'sm d-flex justify-center align-center text-primary outer1'
          : 'lg d-flex justify-center align-center text-primary outer1'
      "
    >
      <div class="d-flex justify-center align-center text-primary outer2">
        <v-app-bar-title
          color="primary"
          class="d-flex justify-center align-center text-primary"
        >
          <div class="d-inline-flex">
            <router-link
              color="primary"
              to="/"
              class="text-primary d-inline"
              style="text-decoration: none"
            >
              <h2
                v-splitting:max="6"
                color="primary"
                class="logo logo-lg d-none d-lg-block"
                :label="$t(siteName)"
              >
                {{ $t(siteName) }}
              </h2>
              <h2
                v-splitting:max="2"
                color="primary"
                class="logo logo-md d-lg-none"
                :label="$t('site.name_short')"
              >
                {{ $t("site.name_short") }}
              </h2>
            </router-link>
            <div class="d-none d-lg-block">
              <RegionSelect />
            </div>
          </div>
        </v-app-bar-title>
      </div>
    </div>

    <v-btn
      v-if="isLoggedIn"
      id="menu-account"
      icon="$mdiAccount"
      size="small"
      class="rounded-xl ml-3 mr-3 on-surface"
    >
    </v-btn>
    <v-menu v-if="isLoggedIn" activator="#menu-account">
      <v-list>
        <v-list-item>
          <v-list-item-title>{{ user.nickname }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/profile">
          <template #prepend>
            <v-icon icon="$mdiAccount"></v-icon>
          </template>
          <v-list-item-title>
            {{ $t("menu.profil") }}
          </v-list-item-title>
        </v-list-item>

        <v-divider v-if="isLoggedIn"></v-divider>

        <v-list-item v-if="isLoggedIn" id="menu-logout" @click.prevent="logout">
          <template #prepend>
            <v-icon>$mdiLogout</v-icon>
          </template>
          <v-list-item-title id="logout">Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn
      v-if="!isLoggedIn"
      id="menu-account"
      icon="$mdiAccountPlus"
      size="small"
      class="rounded-xl ml-5 mr-5 on-surface"
    >
    </v-btn>
    <v-menu v-if="!isLoggedIn" activator="#menu-account">
      <v-list>
        <v-list-item>
          <v-list-item-title>Hier anmelden</v-list-item-title>
        </v-list-item>
        <v-list-item to="/register">
          <template #prepend>
            <v-icon icon="$mdiLogin"></v-icon>
          </template>
          <v-list-item-title>{{ $t("users.register") }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-divider></v-divider>
        </v-list-item>

        <v-list-item>
          <v-list-item-title>Hier einloggen</v-list-item-title>
        </v-list-item>
        <v-list-item to="/login">
          <template #prepend>
            <v-icon icon="$mdiLogin"></v-icon>
          </template>
          <v-list-item-title>{{ $t("users.login") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script setup>
import { computed, ref } from "vue";
import { useLoaderStore } from "@/stores/loader";
import { useSiteStore } from "@/stores/site";
import { useRegionStore } from "@/stores/region";
import { useUserStore } from "@/stores/user";
import { useAuthStore } from "@/stores/auth";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import i18n from "@/i18n";

import Loader from "@/components/loader.vue";

import RegionSelect from "@/components/Region/RegionSelect.vue";

import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";

defineProps({
  appVersion: {
    type: String,
    default: "",
  },
});

const sideNav = ref(false);
const appName = import.meta.env.VITE_TITLE;
const appUrl = import.meta.env.VITE_BASE_URL;

const content_routes = {
  about: ["project", "network", "history", "opensource", "partner"],
  claim: ["general", "regional"],
  definition: ["definition", "legal", "term", "reasons", "harm", "spot"],
  participate: ["how", "donation"],
  press: [],
  support: ["faq", "goodtoknow"],
  contact: [],
};

const router = useRouter();
const loaderStore = useLoaderStore();
const siteStore = useSiteStore();
const regionStore = useRegionStore();
const userStore = useUserStore();
const authStore = useAuthStore();
const toast = useToast();

const loading = computed(() => loaderStore.loading);
const language = computed(() => siteStore.language);
const siteName = computed(() => siteStore.siteName);

const user = computed(() => userStore.getUser);

const isLoggedIn = computed(() => authStore.isLoggedIn);

const menuContent = computed(() => {
  let mdRoutes = [];
  Object.keys(content_routes).forEach((rut) => {
    let subrut = content_routes[rut];
    let key = "site-" + rut + "_" + language.value;
    let path = "/site/" + rut + "_" + language.value;
    let element = [];
    element = router.options.routes.find((x) => {
      if (x.meta.key === key || x.path === path) {
        return x;
      }
    });
    if (element == undefined) {
      element = [];
      element["meta"] = [];
    }
    element["title"] = "menu.content_menu." + rut;

    element["id"] = rut;
    element["icon"] = "$mdiText";
    element["meta"]["title"] = "menu.content_menu." + rut;

    if (subrut.length > 0) {
      element["child"] = [];
      subrut.forEach((srut) => {
        let skey = "site-" + rut + "-" + srut + "_" + language.value;
        let subelement = router.options.routes.find((x) => {
          if (
            x.meta.key === skey ||
            (x.children &&
              x.children.length &&
              x.children[0] &&
              x.children[0].name === skey)
          ) {
            return x;
          }
        });
        if (subelement) {
          subelement["title"] = "menu.content_menu." + rut + "-" + srut;
          subelement["id"] = rut + "-" + srut;
          subelement["icon"] = "$mdiText";
          subelement["meta"]["title"] = "menu.content_menu." + rut + "-" + srut;

          element["child"].push(subelement);
        }
      });
    }
    mdRoutes.push(element);
  });
  return [...mdRoutes];
});
const menuItems = computed(() => {
  let routes = [];
  for (let i in router.options.routes) {
    let route = router.options.routes[i];

    if (Object.hasOwn(route, "title")) {
      if (
        (Object.hasOwn(route, "meta") &&
          Object.hasOwn(route, "component") &&
          !Object.hasOwn(route.meta, "content") &&
          Object.hasOwn(route.meta, "requiresAuth") &&
          ((route.meta.requiresAuth === false && !isLoggedIn.value) ||
            (route.meta.requiresAuth === true && isLoggedIn.value))) ||
        Object.hasOwn(route.meta, "always")
      ) {
        if (Object.hasOwn(route.meta, "requiresRole")) {
          if (
            authStore.getRole.length > 0 &&
            authStore.getRole.includes(route.meta.requiresRole)
          ) {
            routes.push(route);
          }
        } else {
          routes.push(route);
        }
      }
    } else if (Object.hasOwn(route, "children")) {
      // let mdRoute = route.children[0];
      // this.content_routes.forEach((rut) => {
      //   if (mdRoute.name == "site-" + rut + "_" + language.value) {
      //     mdRoute["title"] = "menu.content_menu." + rut;
      //     mdRoute["path"] = route.path;
      //     mdRoute["id"] = rut;
      //     mdRoute["icon"] = "$mdiText";
      //     mdRoute["meta"]["title"] = "menu.content_menu." + rut;
      //     //mdRoutes.push(mdRoute);
      //     return;
      //   }
      // });
    }
  }
  return [...routes];
});

const getCols = function (item) {
  if (
    item.name == "create" ||
    item.name == "register" ||
    item.name == "chart" ||
    item.name.includes("admin") ||
    item.name.includes("Style") ||
    item.name == "login"
  ) {
    return 12;
  } else {
    return 6;
  }
};
const getClass = function (item) {
  if (item.name == "create") {
    return "highlight rounded-sm on-surface";
  } else {
    return "rounded-sm on-surface";
  }
};
const setActive = function (region) {
  loaderStore.show();
  regionStore.fetchRegion(region).then(() => {
    loaderStore.hide();
  });
};
const logout = function () {
  authStore.logout().then(() => {
    toast.success(i18n.global.t("successes.user.logout"));
    router
      .push({
        name: "home",
        replace: true,
      })
      .then((result) => {})
      .catch((err) => {
        console.log("router catch logout", err);
      });
  });
};
const deselect = function () {
  regionStore.clear().then(() => {});
};
</script>
